export interface CloseButtonProps {
  onClick: () => void;
}

export function CloseButton({ onClick }: CloseButtonProps) {
  return (
    <button className="-mr-2 flex cursor-pointer flex-col gap-2 border-0 p-4" onClick={onClick}>
      <div className="bg-foreground h-0.75 w-8 translate-y-1 rotate-45 rounded-sm"></div>
      <div className="bg-foreground h-0.75 w-8 -translate-y-1.5 -rotate-45 rounded-sm"></div>
    </button>
  );
}
